<template>
    <div>
        <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">create service</zm-button>
        <zm-button size="small" @click="showResult()" class="btn-in-line" type="primary">show result</zm-button>
        <zm-table :data="list" v-loading="loading">
            <zm-table-column label="Name" prop="name"></zm-table-column>
            <zm-table-column label="Owner" prop="owner"></zm-table-column>
            <zm-table-column label="Description" prop="description"></zm-table-column>
            <zm-table-column label="Email" prop="email"></zm-table-column>
            <zm-table-column prop="operation" width="220px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)" v-if="hasPermission"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="showDelete(scope.row.id)" v-if="hasPermission"></zm-button>
                    <zm-button type="icon" icon="zm-icon-move-to" title="show service region" @click="showPool(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-device-directory" title="show client" @click="showClient(scope.row)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
                :current-page.sync="pageable.page" :page-size="pageable.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="pageable.total">
            </zm-pagination>
        </div>
        <zm-dialog :title="form.title" :visible.sync="visible">
            <zm-form ref="form" :model="form" :rules="rules" label-width="120px">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="smart-service-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item prop="app">
                    <div slot="label">
                        <tip label="App" id="smart-service-app"></tip>
                    </div>
                    <zm-select size="small" v-model="form.app" filterable style="width: 100%">
                        <zm-option v-for="item in appList" :key="item.id" :label="item.name" :value="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="owner">
                    <div slot="label">
                        <tip label="Owner" id="smart-service-owner"></tip>
                    </div>
                    <zm-input size="small" v-model="form.owner"></zm-input>
                </zm-form-item>
                <zm-form-item prop="email">
                    <div slot="label">
                        <tip label="Email" id="smart-service-email"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.email"></zm-input>
                </zm-form-item>
                <zm-form-item prop="description">
                    <div slot="label">
                        <tip label="Description" id="smart-service-description"></tip>
                    </div>
                    <zm-input size="small" type="textarea" v-model="form.description"></zm-input>
                </zm-form-item>
                <zm-form-item prop="topicPrefix">
                    <div slot="label">
                        <tip label="TopicPrefix" id="smart-service-topicPrefix"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.topicPrefix"></zm-input>
                </zm-form-item>
                <zm-form-item prop="ack" label-width="0">
                    <zm-checkbox v-model="form.ack">
                        <tip label="Ack" id="smart-service-ack"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <div class="zm-form-item zm-form--label-left is-required" prop="tags">
                    <label class="zm-form-item__label" style="width: 120px;">
                        <tip label="Tags" id="smart-service-tags"></tip>
                    </label>
                    <div style="margin-left: 100px;">
                        <zm-tag type=""
                            class="input-tag"
                            :key="tag"
                            v-for="tag in form.tags"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{ tag }}
                        </zm-tag>
                        <zm-input
                            class="input-new-tag"
                            v-if="tagVisible"
                            v-model="tagInput"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm()"
                            @blur="handleInputConfirm()"
                            >
                        </zm-input>
                        <zm-button size="small" v-else class="button-new-tag" @click="showInput()">+</zm-button>
                    </div>
                </div>
                <div class="param-wrapper">
                <zm-form-item prop="settingParam.strategy">
                    <div slot="label">
                        <tip label="Strategy" id="smart-service-strategy"></tip>
                    </div>
                    <zm-select size="small" v-model="form.settingParam.strategy" style="width: 100%">
                        <zm-option v-for="item in Object.keys(strategyList)" :key="item" :label="strategyList[item]" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="counts" label-width="180px">
                    <div slot="label">
                        <tip label="Counts" id="smart-service-counts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.counts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="maxWorkersPerCpu" label-width="180px">
                    <div slot="label">
                        <tip label="Max Workers Per Cpu" id="smart-service-maxWorkersPerCpu"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.maxWorkersPerCpu" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="receiveCounts" label-width="180px">
                    <div slot="label">
                        <tip label="Receive Counts" id="smart-service-receiveCounts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.receiveCounts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="requiredMinInstances" label-width="180px">
                    <div slot="label">
                        <tip label="Required Min Instances" id="smart-service-requiredMinInstances"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.settingParam.requiredMinInstances" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0px">
                    <zm-checkbox v-model="form.settingParam.active">
                        <tip label="Active" id="smart-service-active"></tip>
                    </zm-checkbox>
                </zm-form-item>
                </div>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listService, createService, updateService, deleteService, listStrategy } from '@/api/smart'
import { getAllUser } from '@/api'
import tip from 'components/ToolTip/index'
export default {
    name: 'service',
    components: {
        tip
    },
    data () {
        return {
            role: localStorage.role,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            list: [],
            visible: false,
            appList: [],
            strategyList: [],
            form: {
                title: '',
                id: '',
                name: '',
                app: '',
                description: '',
                email: '',
                owner: '',
                topicPrefix: '',
                ack: false,
                tags: [],
                settingParam: {
                    active: true,
                    counts: '',
                    maxWorkersPerCpu: '',
                    receiveCounts: '',
                    requiredMinInstances: '',
                    strategy: ''
                }
            },
            rules: {
                name: [
                    { required: true, validator: 'please enter role', trigger: 'blur' }
                ],
                app: [
                    { required: true, message: 'please enter app', trigger: 'blur' }
                ],
                owner: [
                    { required: true, validator: 'please enter owner', trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: 'please enter email', trigger: 'blur' }
                ],
                'settingParam.strategy': [
                    { required: true, validator: 'please enter strategy', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ]
            },
            tagInput: '',
            tagVisible: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        this.fetchData()
        this.fetchApp()
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        fetchApp () {
            getAllUser().then(response => {
                this.appList = response
            })
        },
        fetchStrategy () {
            listStrategy().then(response => {
                this.strategyList = response
            })
        },
        showResult () {
            this.$router.push('/dashboard/smart/result')
        },
        showCreate () {
            this.fetchStrategy()
            this.form.title = 'Create Service'
            this.form.id = ''
            this.form.name = ''
            this.form.app = ''
            this.form.description = ''
            this.form.email = ''
            this.form.owner = ''
            this.form.topicPrefix = ''
            this.form.ack = false
            this.form.tags = []
            this.form.settingParam.active = true
            this.form.settingParam.counts = 1
            this.form.settingParam.maxWorkersPerCpu = 1
            this.form.settingParam.receiveCounts = 1
            this.form.settingParam.requiredMinInstances = 1
            this.form.settingParam.strategy = ''
            this.visible = true
        },
        showEdit (row) {
            this.fetchStrategy()
            this.form.title = 'Edit Service'
            this.form.id = row.id
            this.form.name = row.name
            this.form.app = row.app
            this.form.description = row.description
            this.form.email = row.email
            this.form.owner = row.owner
            this.form.topicPrefix = row.topicPrefix
            this.form.ack = row.ack
            this.form.tags = row.tags
            this.form.settingParam.active = row.setting.active
            this.form.settingParam.counts = row.setting.counts
            this.form.settingParam.maxWorkersPerCpu = row.setting.maxWorkersPerCpu
            this.form.settingParam.receiveCounts = row.setting.receiveCounts
            this.form.settingParam.requiredMinInstances = row.setting.requiredMinInstances
            this.form.settingParam.strategy = row.setting.strategy
            this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid && this.form.tags.length) {
                    const { id, name, app, description, email, owner, ack, topicPrefix, tags, settingParam } = this.form
                    const data = { name, app, description, email, owner, ack, topicPrefix, tags, settingParam }
                    if (id) {
                        this.loading = true
                        updateService(id, data).then(() => {
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = true
                        createService(data).then(() => {
                            this.loading = false
                            this.visible = false
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.$message.error('Submit error!')
                }
            })
        },
        showDelete (id) {
            this.$confirm('This will permanently delete the service. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteService(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete service success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showPool (row) {
            this.$router.push('/dashboard/smart/pool/' + row.name + '/' + row.id)
        },
        showClient (row) {
            this.$router.push('/dashboard/smart/client/' + row.name + '/' + row.id)
        },
        fetchData () {
            this.loading = true
            listService(this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, total } = response
                this.list = content
                this.pageable.total = total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleClose (tag) {
            this.form.tags.splice(this.form.tags.indexOf(tag), 1)
        },
        showInput () {
            this.tagVisible = true
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm () {
            var inputTagValue = this.tagInput
            if (inputTagValue) {
                if (this.form.tags.indexOf(inputTagValue) === -1) {
                    this.form.tags.push(inputTagValue)
                } else {
                    this.$message({
                        type: 'warning',
                        message: 'Duplicated value'
                    })
                }
            }
            this.tagVisible = false
            this.tagInput = ''
        }
    }
}
</script>
<style>
.param-wrapper {
    border: solid 1px rgba(195, 195, 195, 0.5);
    border-radius: 8px;
    padding: 10px;
}
.input-tag {
  margin-right: 10px;
  padding:  0 20px 0 10px;
}
.input-new-tag.zm-input {
  width: 200px;
  vertical-align: baseline;
}
.button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    vertical-align: bottom;
}
</style>
